import { findById } from '@/utils/find-by-id';
import { useGroups } from './use-groups';

export const useGroup = (id: number) => {
  const result = useGroups();

  const group = findById(result.data, id);

  return { ...result, data: group };
};
